


















































import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";
import { SigninPayload } from "./interfaces/payload.interface";

@Component
export default class SigninForm extends Vue {
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) isOtpRequired: boolean;
  @Prop({}) refPin: string;
  form: SigninPayload = {
    username: "",
    password: "",
    code: ""
  };

  @Emit("on-submit")
  async onSubmit() {
    return this.form;
  }
}
